export default {
    excluded: 'Excluded',
    lost: 'Lost',
    recycled: 'Recycled',
    retail: 'Retail',
    return: 'Return',
    wholesale: 'Wholesale',
    tbd: 'TBD',
};
